/**
 * @generated SignedSource<<cfc80c7a418df5c8a96ab007ba982417>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type longReadArticleArticle$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleLandingBannerArticle" | "blockquoteLongReadContent" | "globalCheckerContent">;
  readonly " $fragmentType": "longReadArticleArticle";
};
export type longReadArticleArticle$key = {
  readonly " $data"?: longReadArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"longReadArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "longReadArticleArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleLandingBannerArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "globalCheckerContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "blockquoteLongReadContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "4d928d46964da6899ed7f454a4819472";

export default node;
